import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskReportsSatisfaction2Route: InvariantJiraRoute = {
	name: 'servicedesk-reports-satisfaction',
	path: '/jira/servicedesk/projects/:projectKey/reports/all-rating',
};
